<template>
    <div id="main">
        <div  id="viewer1" v-show="this.pshow">
             <van-nav-bar
    title="房间全景图"
    left-text="返回"
    left-arrow
    @click-left="onClickLeft"
  />
        </div>
    </div>    
</template>
<script>
import {Viewer} from 'photo-sphere-viewer'
import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
export default {
    data() {
        return {
            pshow:true,
            use:true,
            psv:'',
            id:'',
            readyLoad:'',
            imageLoaded:'',
            longitude:'',//目前经度
            latitude:'',//目前纬度
            marker3:require('../assets/logo.png'),
            imageloading:[
                {
                    imgurl:require('../assets/93758.jpg'),                  
                },
                {
                    imgurl:require('../assets/0100.jpg'),                    
                }
            ],   
        };
    },
    setup () {
        
    },
    mounted () {
        this.initPhotoSphere(this.imageloading[0]);
      
    },
    methods: {
        initPhotoSphere:function(temp_img){
                const viewers=new Viewer({
                // Container
                container: document.getElementById('viewer1'),
                // Panorama, given in base 64
                panorama: temp_img.imgurl,
                // // Deactivate the animation
                // time_anim: false,
                caption: '房间全景图',
                // Display the navigation bar
                navbar:true,
                size: {
                    width: '100%',
                    height: this.isMobile() ? screen.availHeight-170 : '800px'
                },
                plugins: [
                   
                ],
            });


            viewers.on('position-updated',function(po){
                var span1 = document.getElementById('long');
                span1.innerHTML = po.args[0].longitude;
                var span2 = document.getElementById('lat');
                span2.innerHTML = po.args[0].latitude;            
            })
        },
        isMobile() {
            let flag = navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            return flag;
        },
    onClickLeft() {
      history.go(-1);
    }
    }
}
</script>

<style>
    .hi{
        color: red;
        font-size: 20px;
        text-align: left;
    }
</style>